<template>
    <table-simple-value :value="value">
        <div v-if="value.onclick != undefined" class="d-flex align-items-center">
            <a href="javascript:void(0)" @click="(e) => onclick(e, value)">
                {{ value.value }}
            </a>
        </div>
        <div v-else class="d-flex align-items-center">
            {{ value.value }}
        </div>
        <template v-if="value.status">
            <v-icon v-ripple v-if="value.statusClick" :icon="value.status" class="status" @click="e => statusClick(e, value)"></v-icon>
            <v-icon v-else :icon="value.status" class="status"></v-icon>
        </template>
    </table-simple-value>
</template>

<script>
import TableSimpleValue from './TableSimpleValue.vue';

export default {
    name: 'TableActionValue',
    components: {
        TableSimpleValue,
    },
    props: {
        value: {
            type: Object,
            default() {
                return {
                    onclick: null,
                    icon: null,
                    actions: null,
                    color: '',
                    value: '',
                    status: null,
                    statusClick: null,
                };
            },
        },
    },
    computed: {
        icon_style() {
            if (this.value.color != null) {
                return `color:${this.value.color};`;
            }
            return '';
        },
    },
    methods: {
        onclick(e, action) {
            e.stopPropagation();
            action.onclick(action);
        },
        statusClick(e, action) {
            if (action.statusClick !== undefined) {
                e.stopPropagation();
                action.statusClick(action);
            }
        },
    },
};
</script>

<style scoped>
a {
    color: rgb(var(--v-theme-on-surface));
}
.status {
    width: 32px;
    height: 32px;
    align-items: center;
    margin-left: 8px;
    border-radius: 50%;
}
</style>
